module.exports = "/packs/images/homepage/activity/swimming_tablet~58dbcdd6ed69e9774a84c640718e07ec.jpg";